import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAllApplications, selectApplicationsByAppId } from './store/reducers';
import { UUID } from 'angular2-uuid';
import * as ApplicationActions from './store/actions/applications.actions';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Application } from '../models/application.model';
// import * as MediaLibraryActions from '../media-libraries/store/actions/media-libraries.actions';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {
  messages$: any;

  constructor(
    private store: Store<any>,
    protected db: AngularFirestore,
  ) {

    const preApplications = [
      '1st message',
      '2nd message',
      '3rd message',
      '4th message',
      '5th message'
    ];

    // this.messages$ = this.application.select(selectAllApplications);

    // for (let i = 0; i < preApplications.length; i++) {
    //   this.addApplication(preApplications[i]);
    // }


  }


  addApplication(value: any) {
    const application: Application = {
      appId: value.appId,
      description: value.description,
      costPrice: value.costPrice,
      sellingPrice: value.sellingPrice,
      name: value.name
    };
    this.store.dispatch(new ApplicationActions.AddApplication(application));

  }

  addApplicationFirebase$(application: Application) {
    return this.db.collection('applications').add(application);
  }

  setApplicationFirebase$(application: Application) {
    return this.db.collection('applications').doc(application.id).set({ ...application });
  }

  deleteApplication(id: any) {
    this.store.dispatch(new ApplicationActions.DeleteApplication(id));
  }

  destroyApplication(id: any) {
    this.store.dispatch(new ApplicationActions.DestroyApplication(id));
  }

  destroyApplicationFirebase$(id: string) {
    return this.db.collection('applications').doc(id).delete();
  }

  updateApplication(application: any) {
    // message.dateResolved = new Date();
    this.store.dispatch(
      new ApplicationActions.UpdateApplication(application)
    );

  }

  updateApplicationFirebase$(application: any) {
    console.log('updateApplicationFirebase$: e', application);

    const productsRef: AngularFirestoreDocument<Application> = this.db.collection('applications').doc(application.id);
    const applicationData: any = application;

    return of(productsRef.set(applicationData, { merge: true }));
  }

  getApplications() {
    this.store.dispatch(new ApplicationActions.FetchApplications());
  }

  getApplicationsByAppId(appId: string) {
    this.store.dispatch(new ApplicationActions.FetchApplicationsByAppId(appId));
  }

  getApplicationsByCompanyId(companyId: string) {
    this.store.dispatch(new ApplicationActions.FetchApplicationsByCompanyId(companyId));
  }

  getApplicationsByCompanyIdSiteId(companyId: string, siteId: string) {
    this.store.dispatch(new ApplicationActions.FetchApplicationsByCompanyIdSiteId(companyId, siteId));
  }

  getApplications$(): Observable<any> {

    const applicationsCollection = this.db.collection<any>('applications', ref => ref
    );

    return applicationsCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getApplicationsByCompanyId$(companyId: string): Observable<any> {

    const applicationsCollection = this.db.collection<any>('applications', ref => ref
      .where('companyId', '==', companyId)
    );

    return applicationsCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getApplicationsByAppId$(appId: string): Observable<any> {

    const applicationsCollection = this.db.collection<any>('applications', ref => ref
      .where('appId', '==', appId)
    );

    return applicationsCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getApplicationsByCompanyIdSiteId$(companyId: string, siteId: string): Observable<any> {

    const applicationsCollection = this.db.collection<any>('applications', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
    );

    return applicationsCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  findcompaniesByAppId(appId: number): Observable<Application[]> {

    return this.store.select(selectApplicationsByAppId, { appId });

  }

  findApplications(): Observable<Application[]> {

    return this.store.select(selectAllApplications);

  }
  generateUUID() {
    return UUID.UUID();
  }
}
